import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input } from "rbx";

import { SystemCodeSelect, BooleanInput } from "../inputs";

function VehicleInspectionMasterForm({ inputs, onChange }) {
  return (
    <React.Fragment>
      <Field kind="group">
        <Control expanded>
          <SystemCodeSelect
            icon="search"
            label="Inspection Type"
            lookup={{ Category: "Inventory", Code: "InspectionCd" }}
            name="InspectionTypeRecIdRef"
            value={inputs.InspectionTypeRecIdRef}
            onChange={onChange}
          />
        </Control>
      </Field>
      <Field kind="group">
        <Control expanded>
          <Label>Mileage Interval</Label>
          <Input
            autocomplete="new"
            name="MileageInterval"
            type="text"
            value={inputs.MileageInterval}
            onChange={onChange}
          />
        </Control>
        <Control expanded>
          <Label>Days Interval</Label>
          <Input
            autocomplete="new"
            name="DaysInterval"
            type="text"
            value={inputs.DaysInterval}
            onChange={onChange}
          />
        </Control>
        <Control expanded>
          <Label>Active</Label>
          <BooleanInput
            name="Active"
            value={inputs.Active}
            onChange={onChange}
          />
        </Control>
      </Field>
    </React.Fragment>
  );
}

VehicleInspectionMasterForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};
VehicleInspectionMasterForm.defaultProps = {
  inputs: {}
};
export default VehicleInspectionMasterForm;
